import { t } from 'i18next';

import User from '../../../interfaces/user';

export const getUserFullName = (user: Pick<User, 'firstName' | 'lastName'>): string => {
	const first = user.firstName?.trim() ?? '';
	const last = user.lastName?.trim() ?? '';
	const fullName = [first, last].filter(Boolean).join(' ');
	return fullName !== '' ? fullName : t('unknown', { ns: 'status' });
};

export const getUserInitials = (
	user: Pick<User, 'firstName' | 'lastName'>,
	fallbackChar = '_'
): string => {
	const firstInitial = user.firstName?.trim()?.[0]?.toUpperCase();
	const lastInitial = user.lastName?.trim()?.[0]?.toUpperCase();
	return `${firstInitial ?? fallbackChar}${lastInitial ?? fallbackChar}`;
};

export default getUserFullName;
